module.exports = __webpack_public_path__ + "static/media/imageMA.846f16a8.webp";